seedWebApp.controller('SendEmailModalController', ['$scope', '$uibModalInstance', 'ToastService', 'LogisticsService', 'TranslationService', 'items', 'filter',
    function ($scope, $uibModalInstance, ToastService, LogisticsService, TranslationService, items, filter) {
        $scope.items = items;
        $scope.filter = filter;

        //console.log('items', items);

        //Rules para exemplo de modelo CLIENTE
        //$scope.email = $scope.filter.email;
        //shallow copy do email
        $scope.email = Object.assign({}, $scope.filter.email);

        $scope.ruleFields = '*Booking; *VesselName; *ShipDate';
        
        $scope.translation = TranslationService.getActiveTranslation();
        $scope.loading = true;
        //$scope.actualYear = (new Date()).getFullYear();
        
        //manda somente selecionados
        $scope.sel = [];
        $scope.items.forEach(function (item) {
            $scope.sel.push(item.ProcExpID);
        })

        $scope.orders = [];
        $scope.items.forEach(function (item) {
            $scope.orders.push(item.OrderID);
        })

        $scope.item = {};
        $scope.item.EmailRecipients = 'loading...'; //$scope.email.recipients;
        $scope.item.EmailSubject = $scope.email.EmailSubject;
        $scope.item.EmailHeader = $scope.email.EmailHeader;
        $scope.item.EmailBody = $scope.email.EmailBody;

        $scope.item.EmailID = $scope.email.EmailID;

        $scope.item.DocTypes = $scope.email.docs.map(function (item) {
            return item.DocTypeID;
        });        

        //VALIDAÇÃO DO EMAIL
        $scope.errors = [];
        $scope.errors.push('Carregando email...');
        //$scope.errors.push('Pedido ' + $scope.sel[1] + ', faltam os documentos: Order Confirmation, Order Invoice');

        $scope.fillEmail = function (email, orders) {
            $scope.loading = true;
            var toastID = ToastService.createToast('Loading', 'Filling Email', 8000, 'wait');
            LogisticsService.fillEmail(email, orders).then(function (response) {
                $scope.loading = false;       
                //console.log('EMAIL PREENCHIDO!', response.data);
                var respEmail = response.data.email;
                var respErrors = response.data.errors;
                $scope.errors = respErrors;

                $scope.item.ShippingDate = respEmail.ShippingDate;
                $scope.item.ShippingDates = respEmail.ShippingDates;
                $scope.item.ContactIDs = respEmail.ContactIDs;
                $scope.item.VesselNames = respEmail.VesselNames;
                
                $scope.item.EmailRecipients = respEmail.EmailRecipients;
                $scope.item.EmailCC = respEmail.EmailCC;
                $scope.item.EmailSubject = respEmail.EmailSubject;
                $scope.item.EmailHeader = respEmail.EmailHeader;
                $scope.item.EmailBody = respEmail.EmailBody;
                $scope.item.LinkID = respEmail.LinkID;

                //attachments
                $scope.item.SendAttachments = respEmail.SendAttachments;
                $scope.item.Attachments = response.data.attachments;      

                $scope.email.Adresses = response.data.adresses;
                

                ToastService.updateToast(toastID, 'Loaded', 'Filled!', 4000, 'success');
            }, function (error) {
                console.log('Error loading emails');
                ToastService.updateToast(toastID, 'Error', $scope.getErrorMessage(error), 4000, 'error');
            });
        };

        $scope.fillEmail($scope.email, $scope.orders);

        $scope.canSendEmail = function () {
            if ($scope.loading) {
                return false;
            }
            return $scope.errors.length == 0 && $scope.isRecipientsValid();
        };

        $scope.isRecipientsValid = function () {
            return $scope.item.EmailRecipients && $scope.item.EmailRecipients != '';
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.recipientsErrorMsg = function () {
            if ($scope.isRecipientsValid()) {
                return "";
            }
            else {
                return "Recipients cannot be empty";
            }
        };

        $scope.getErrorMessage = function (err) {
            var errMsg = '';
            if (err.data && err.data.ExceptionMessage) {
                errMsg = err.data.ExceptionMessage;
            }
            return errMsg;
        };

        $scope.sendEmail = function () {
            $scope.loading = true;

            //$scope.item.EmailID = $scope.email.EmailID;
            var email = $scope.item;
            var orders = $scope.orders;

            //console.log('sendEmail', email);
            $scope.sendEmailErrors = [];
            var toastID = ToastService.createToast($scope.translation.Sending, '', 4000, 'wait');
            LogisticsService.sendEmail(email, orders).then(function (response) {
                $scope.loading = false;
                //console.log('EMAIL PREENCHIDO!', response.data);
                //var respEmail = response.data.email;

                var respErrors = response.data.errors;
                $scope.errors = respErrors;
                if ($scope.errors && $scope.errors.length) {
                    ToastService.updateToast(toastID, 'Error', 'Errors found', 4000, 'error');
                }
                else {
                    ToastService.updateToast(toastID, 'Sent', 'Email Sent', 4000, 'success');
                    $uibModalInstance.close('sent');

                }
            }, function (error) {
                $scope.loading = false;
                //console.log('Error sending emails', error);
                var errMsg = $scope.getErrorMessage(error);

                //Erro ao enviar, permite novamente
                var excType = '';
                if (error.data && error.data.ExceptionMessage) {
                    excType = error.data.ExceptionType;
                }
                
                if (excType.contains('+SendEmailException')) {
                    $scope.sendEmailErrors.push(errMsg);
                    ToastService.updateToast(toastID, 'SEND Error', errMsg, 4000, 'error');
                }
                else {
                    $scope.errors.push(errMsg + ' ' + excType);
                    ToastService.updateToast(toastID, 'Error', errMsg, 4000, 'error');
                }
                
            });            
            
        };
    }
]);
